export default defineNuxtPlugin(() => {
  const { proxy: umami } = useScriptUmamiAnalytics()

  return {
    provide: {
      umami,
    },
  }
})
